import {useEffect, useRef, useState} from 'react'
import {publish, subscribe, unsubscribe} from '@/script/event.mjs'

export default () => {
    const refEditingNode = useRef(null)

    const extensions = () => ({
        canEditNodeText(node) {
            return true
        },

        editNodeText(node, text) {
            this.execute(() => node.text = text)
        },

        finishEditNodeText(node) {
            refEditingNode.current = null
            publish(this, 'edit_node_text', null)
            publish(node, 'edit_text_end')
            this.finishTask()
        },

        isNodeEditingText(node) {
            return refEditingNode.current === node
        },

        startEditNodeText(node, text) {
            refEditingNode.current = node
            this.startTask()
            publish(this, 'edit_node_text', node)
            publish(node, 'edit_text_start')
            this.editNodeText(node, text)
        },

        useIsEditingText(node) {
            const [isEditing, setIsEditing] = useState(
                refEditingNode.current === node
            )

            useEffect(
                () => {
                    const handleEditEnd = () => setIsEditing(false)
                    const handleEditStart = () => setIsEditing(true)
                    subscribe(node, 'edit_text_end', handleEditEnd)
                    subscribe(node, 'edit_text_start', handleEditStart)

                    return () => {
                        unsubscribe(node, 'edit_text_end', handleEditEnd)
                        unsubscribe(node, 'edit_text_start', handleEditStart)
                    }
                },

                [node]
            )

            return isEditing
        },
    })

    return {extensions}
}
